<template>
  <div class="job-category">
    <v-row>
      <v-col cols="4">
        <v-select 
          v-model="search.taskType" 
          :items="taskTypes"
          item-text="label"
          item-value="value"
          label="Task Type"
        ></v-select>
      </v-col>
      <v-col v-if="showInstall" cols="4">
        <v-text-field v-model="search.installTag" label="Install Tag"></v-text-field>
      </v-col>
      <v-col v-if="showVehicleOrg" cols="4">
        <v-text-field v-model="search.vehicleName" label="Vehicle Name"></v-text-field>
      </v-col>
      <v-col v-if="showVehicleOrg" cols="4">
        <v-text-field v-model="search.organisation" label="Organisation"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="7">
        <material-date-time-range 
          :start-value="startValue" 
          :local-time="true"
          :label="'Creation Date'"
          @change="range => dateRange = range">
        </material-date-time-range>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.jobTitle" label="Job Title"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.jobCreatedBy" label="Job Created By"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.jobAssignee" label="Job Assignee"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.taskTitle" label="Task Title"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.taskAssignee" label="Task Assignee"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.taskPerformedBy" label="Task Performed By"></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import moment from "moment";

import { Logger } from "aws-amplify"
const logger = new Logger("Advanced Search / Jobs")

export default {
  name: 'Jobs',
  props: {
    reset: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      startValue: [
        moment()
          .subtract(7, "days")
          .startOf("day")
          .utc()
          .format()
          .split("Z")
          .join(""),
        moment()
          .endOf("day")
          .utc()
          .format()
          .split("Z")
          .join("")
      ],
      searching: false,
      taskTypes: [
        {
          label: 'All',
          value: 'all'
        },
        {
          label: 'Install',
          value: 'taskinstall'
        },
        {
          label: 'Config',
          value: 'device_config'
        },
        {
          label: 'Firmware Update',
          value: 'firmwareupdate'
        }
      ],
      search: {
        installTag: '',
        vehicleName : '',
        organisation: '',
        taskType: '',
        jobTitle: '',
        jobCreatedBy: '',
        jobAssignee: '',
        taskTitle: '',
        taskAssignee: '',
        taskPerformedBy: ''
      },
      dateRange: [
        moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss")
      ]
    }
  },
  computed: {
    showInstall() {
      return this.search.taskType == 'taskinstall' ? true : false;
    },
    showVehicleOrg() {
      return this.search.taskType == 'device_config' || this.search.taskType == 'firmwareupdate' ? true : false;
    },
    // tasks the user has permissions to auth
    allowedTaskTypes () {
      return this.taskTypes.filter(i => !this.hideTask[i.value])
    },
    hideTask () {
      return {
        taskinstall: !this.$can('createDeviceInstallJob'),
        firmwareupdate: !this.$can('createFirmwareUpdateJob'), 
        device_config: !this.$can('createDeviceConfigJob')
      }
    }
  },
  watch: {
    search: {
      handler(val) {
        this.$emit('updatedSearchCriteria', val)
      },
      deep: true
    },
    dateRange: {
      handler(val) {
        this.$emit('updatedDateRange', val)
      }
    },
    reset() {
      this.resetFields();
    }
  },
  mounted() {
    this.$emit('updatedDateRange', this.dateRange)
    this.search.taskType = 'all'
    this.dateRange = this.startValue;
  },
  methods: {
    resetFields() {
      logger.info('clear them fields')

      for (var key in this.search) {
        if (this.search.hasOwnProperty(key)) {
          this.search[key] = '';
        }
      }
      this.search.taskType = 'all'
    }
  }
}
</script>